export default function Checkout({ mobileOnly = false, desktopOnly = !mobileOnly }) {
    return (
            <button
                type="button"
                className="esc-ii-w-full esc-ii-py-5 esc-ii-rounded esc-ii-bg-black esc-ii-mt-6"
            >
                <span className="esc-ii-text-white esc-ii-uppercase">
                    Checkout Now
                </span>
            </button>
    );
}
